import React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faFacebookF,
  faInstagram,
  faWhatsapp,
  faGoogle,
} from "@fortawesome/free-brands-svg-icons"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

const ContactPage = () => {
  return (
    <Layout>
      <Seo title="Contact" />
      <div className="bg-stone-100">
        <section>
          <div className="flex justify-center bg-bump-gray px-8 py-8 shadow-sm md:py-12 md:px-40">
            <p className="font-Roboto text-5xl font-bold text-stone-100 md:text-7xl">
              get in touch.
            </p>
          </div>
        </section>

        {
          //Card Section
        }
        <section className="px-6 py-4 text-bump-gray md:px-36 md:py-12">
          <div className="mx-auto  ">
            <div className="flex-col border-stone-800 bg-white ">
              <div className="container mx-auto flex flex-col  md:flex-row">
                <div className="flex w-full flex-col px-8 py-6 shadow-sm md:py-14 md:px-16  lg:w-3/5">
                  <p className="my-4 font-Roboto text-3xl font-black text-bump-gray md:text-7xl">
                    hit us up.
                  </p>
                  <p className="my-2 font-OpenSans normal-case md:my-4">
                    <svg
                      className="mr-2 inline-block fill-current"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path d="M12 0c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z" />
                    </svg>
                    Lot 1.051, Level 1, The School, Jaya One, 72A Jalan Profesor
                    Diraja Ungku Aziz, PJS 13, Petaling Jaya, 46200 Selangor,
                    Malaysia
                  </p>
                  <p className="my-2 font-OpenSans md:my-4 ">
                    <svg
                      className="mr-2 inline-block fill-current"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path d="M12 12.713l-11.985-9.713h23.971l-11.986 9.713zm-5.425-1.822l-6.575-5.329v12.501l6.575-7.172zm10.85 0l6.575 7.172v-12.501l-6.575 5.329zm-1.557 1.261l-3.868 3.135-3.868-3.135-8.11 8.848h23.956l-8.11-8.848z" />
                    </svg>{" "}
                    hello@bumpbouldering.com
                  </p>
                  <p className="my-2 font-OpenSans md:my-4 ">
                    <svg
                      className="mr-2 inline-block fill-current"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path d="M20 22.621l-3.521-6.795c-.008.004-1.974.97-2.064 1.011-2.24 1.086-6.799-7.82-4.609-8.994l2.083-1.026-3.493-6.817-2.106 1.039c-7.202 3.755 4.233 25.982 11.6 22.615.121-.055 2.102-1.029 2.11-1.033z" />
                    </svg>
                    018-360 4355
                  </p>{" "}
                  <p className="mt-2 font-Roboto text-lg font-bold text-bump-blue md:mt-4 md:text-3xl">
                    socials
                  </p>
                  <div className="mt-2 flex items-baseline space-x-4 align-middle">
                    <a
                      href="https://www.facebook.com/bumpboulderingKL/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon
                        icon={faFacebookF}
                        inverse
                        size="lg"
                        className="text-bump-gray"
                      />
                    </a>

                    <a
                      href="https://www.instagram.com/bumpbouldering"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon
                        icon={faInstagram}
                        inverse
                        size="lg"
                        className="text-bump-gray"
                      />
                    </a>

                    <a
                      href="https://api.whatsapp.com/send?phone=60183604355"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon
                        icon={faWhatsapp}
                        inverse
                        size="lg"
                        className="text-bump-gray"
                      />
                    </a>

                    <a
                      href="mailto:hello@bumpbouldering.com?subject=Enquiry for Bump Bouldering&body=Hello, I have a question."
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon
                        icon={faGoogle}
                        inverse
                        size="lg"
                        className="text-bump-gray"
                      />
                    </a>
                  </div>
                  <p className="mt-2 font-Roboto text-lg font-bold text-bump-blue md:mt-8 md:text-3xl">
                    operating hours
                  </p>
                  <p className="my-2 font-OpenSans normal-case md:my-4 ">
                    <span className="font-bold">Monday to Friday:</span> 12:00pm
                    - 10:00pm <br />
                    <span className="font-bold">
                      Saturday, Sunday & Public Holiday:
                    </span>{" "}
                    9:00am - 7:00pm
                  </p>
                </div>
                <div className="flex w-full lg:w-2/5">
                  <StaticImage
                    src="../images/contact-us.webp"
                    alt="contact"
                    objectFit="cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <section
        className="container flex justify-center align-middle h-screen min-w-full bg-fixed bg-center bg-cover classes-banner transition-[height] duration-[99999999ms] ease-in-out"
      >
        <div className="flex flex-col w-full px-12 py-48 md:px-24 md:py-40 z-20">
          
          <Fade duration={3000}>
            <div className="text-5xl flex justify-center text-center md:text-[10rem] text-white font-Roboto font-bold">
              <p className="text-white"> <span className="font-black text-white">Discover</span> Movement.</p>
            </div>
          </Fade>

          
          <div className="text-base md:text-xl max-w-2xl text-white font-thin italic font-OpenSans">
            
          </div>



        </div>

        <div className="absolute z-0 w-full h-full bg-gradient-to-b from-black/30  via-black/10"></div>
      </section>

      <section>
      <div className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:text-center">
          <h2 className="text-base text-bump-yellow font-Roboto font-semibold tracking-wide uppercase">Courses</h2>
          <p className="mt-2 text-3xl  font-Roboto font-black  text-gray-900 sm:text-4xl">
            Develop your climbing fundamentals.
          </p>
          <p className="mt-4 max-w-2xl text-lg text-gray-500 lg:mx-auto font-OpenSans">
            If you are new to bouldering, have no fear! This course is designed to teach you all the fundamentals you need to become a proper boulderer.
          </p>
        </div>

        <div className="mt-10">
          <dl className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
            {features.map((feature) => (
              <div key={feature.name} className="relative">
                <dt>
                  <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white">
                  </div>
                  <p className="ml-16 text-lg leading-6 font-medium text-gray-900">{feature.name}</p>
                </dt>
                <dd className="mt-2 ml-16 text-base text-gray-500">{feature.description}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
    </section> */}
      </div>
    </Layout>
  )
}

export default ContactPage
